import { useState, useContext } from 'react';
import papaparse from 'papaparse';
import lodash from 'lodash';
import { AppContext } from 'commons-ui';
import { useHistory } from 'react-router-dom';
import useService from '../../utils/useService';
import { prepareCreateSchema } from '../../utils';

const useUpload = () => {
	const [csvFile, setCSVFile] = useState<File | null>(null);
	const [deleteExistingSchema, setDeleteExistingSchema] = useState(false);
	const [showLoader, setShowLoader] = useState(false);
	const { app, showAlert } = useContext(AppContext);
	const { requestCreateSchemaBulk } = useService();
	const history = useHistory();

	const handleFileUpload = async (uploadedFiles) => {
		const file = lodash.first(uploadedFiles);
		if (!lodash.isEmpty(file)) await setCSVFile(file);
	};

	const handleDeleteExistingToggle = () => {
		setDeleteExistingSchema(!deleteExistingSchema);
	};

	const CSVtoJSON = (csvText: string) => {
		const parsedData = papaparse.parse(csvText, { header: true, skipEmptyLines: true });
		return parsedData.data;
	};

	const bulkMttSchemaCreate = async (jsonData) => {
		if (!jsonData) return;
		setShowLoader(true);
		const schemaList = [];
		for (let i = 0; i < jsonData.length; i += 1) {
			schemaList.push(prepareCreateSchema(jsonData[i]));
		}
		const { data } = await requestCreateSchemaBulk(app.appName, { deleteExistingSchema, schemaList });
		if (data.success) showAlert('CSV upload successfully.', { type: 'success' });
		else showAlert(data.externalMessage || 'some error ocurred while uploading csv', { type: 'error', duration: 'MEDIUM' });
		history.goBack();
	};

	const uploadCsvFile = () => {
		if (!csvFile) return;

		const reader = new FileReader();
		reader.onload = () => {
			const text = reader.result?.toString() || '';
			const data = CSVtoJSON(text);
			bulkMttSchemaCreate(data);
		};
		reader.readAsText(csvFile);
	};

	return {
		showLoader,
		showAlert,
		csvFile,
		deleteExistingSchema,
		handleFileUpload,
		uploadCsvFile,
		handleDeleteExistingToggle
	};
};

export default useUpload;
